import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, List, Avatar, Typography, Card, Divider, Space, Empty, Spin } from "antd";
import {
  CarOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  WarningOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import api from "../../../axiosConfig";

const { Text } = Typography;

function HistorialVehiculoDialog({ open, onClose, vehiculoId }) {
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (vehiculoId && open) {
      setLoading(true);
      api
        .get(`/vehiculos/historial/${vehiculoId}`)
        .then((response) => {
          setHistorial(response.data);
        })
        .catch((error) => {
          console.error("Error al obtener el historial:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [vehiculoId, open]);

  const getIconByAction = (action, actorType) => {
    // Si es una acción del sistema, usar icono de robot
    if (actorType === 'sistema') {
      return <RobotOutlined style={{ color: "#FF5722" }} />;
    }

    switch (action) {
      case "Creación de Vehículo":
        return <CarOutlined style={{ color: "#4CAF50" }} />;
      case "Actualización de Vehículo":
        return <CheckCircleOutlined style={{ color: "#FFC107" }} />;
      case "Eliminación de Vehículo":
        return <CloseCircleOutlined style={{ color: "#F44336" }} />;
      case "Suspensión Automática":
        return <WarningOutlined style={{ color: "#FF5722" }} />;
      default:
        return <ClockCircleOutlined style={{ color: "#1976D2" }} />;
    }
  };

  const getAvatarStyle = (actorType) => {
    if (actorType === 'sistema') {
      return { backgroundColor: "#FF5722" };
    }
    return { backgroundColor: "#3F51B5" };
  };

  const getActorName = (registro) => {
    if (registro.actor_type === 'sistema') {
      return 'Sistema';
    }
    return registro.usuario?.nombre || 'Usuario desconocido';
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <Text strong style={{ color: "#2E3B4E" }}>
          Historial del Vehículo
        </Text>
      }
      footer={null}
      width={800}
      centered
      style={{ borderRadius: "15px" }}
    >
      <Spin spinning={loading} tip="Cargando historial...">
        <div style={{ backgroundColor: "#f9f9f9", padding: "20px", minHeight: "200px" }}>
          {historial.length === 0 && !loading ? (
            <Empty description="No hay registros en el historial" />
          ) : (
            <List
              itemLayout="vertical"
              dataSource={historial}
              renderItem={(registro, index) => (
                <div key={registro.id}>
                  <Card
                    style={{ borderRadius: "8px", backgroundColor: "#fff" }}
                    variant="borderless"
                  >
                    <List.Item>
                      <Space align="start" size="large">
                        <Avatar style={getAvatarStyle(registro.actor_type)}>
                          {registro.actor_type === 'sistema'
                            ? <RobotOutlined />
                            : (registro.usuario?.nombre?.charAt(0) || '?')}
                        </Avatar>
                        <div>
                          <Text
                            strong
                            style={{ color: "#2E3B4E", fontSize: "16px" }}
                          >
                            {`${getActorName(registro)} - ${registro.accion}`}
                          </Text>
                          <Text
                            style={{
                              display: "block",
                              marginTop: "8px",
                              marginBottom: "8px",
                            }}
                          >
                            {registro.descripcion}
                          </Text>
                          <Space>
                            {getIconByAction(registro.accion, registro.actor_type)}
                            <Text type="secondary">
                              {new Date(registro.fecha).toLocaleString()}
                            </Text>
                          </Space>
                        </div>
                      </Space>
                    </List.Item>
                  </Card>
                  {index < historial.length - 1 && <Divider />}
                </div>
              )}
            />
          )}
        </div>
      </Spin>
    </Modal>
  );
}

HistorialVehiculoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  vehiculoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default HistorialVehiculoDialog;
